export default "__VITE_ASSET__1p6LRosf__"